
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterDoGoogle as ObiSensorWaterDoGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-do-google.js';
 
 
 

 
 export const ObiSensorWaterDoGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-do-google',
   elementClass: ObiSensorWaterDoGoogleElement,
   events: {
     
   }
  });
 
 